import {
    GREEN_CARD,
    PLATINUM_CARD,
    YELLOW_CARD,
    QUICK_CASH,
    PBP,
    DEPOSIT_CREDIT_ORDINARY,
    BUSINESS_CREDIT_LINE,
    BUSINESS_A_EXPRESS,
    DEPOSIT_CREDIT,
    BUSINESS_RKO,
    BUSINESS_DEPOSITS,
    BUSINESS_GUARANTEES,
    ABANK24,
    PAYMENTS,
    DOCUMENTS,
    SERVICES_TRANSFERS,
    SAFE_BOXES,
    SERVICE_LEASING,
    INSURANCE,
    ABOUT_BANK_GENERAL,
    ABOUT_BANK_OWNERS,
    ABOUT_BANK_REPORTS,
    ABOUT_BANK_TOP,
    ABOUT_BANK_STRATEGY,
    BUSINESS_ACQUIRING,
    BUSINESS_VED_CONTRACT,
    PENSION,
    PBP_ENTITY,
    PESSONAL_DATA,
    ACCEPTING_PAYMENTS,
    BUSINESS_COLLECTION,
    PROJECT_SUPPORT,
    PAYMENT_BY_PHONE,
    ABROAD,
    WAR_TIME,
    TRANSFER_BONUS,
    ONLINE_DEPOSIT,
    FGVO,
    CALCULATOR_DEPOSIT,
    TARIFFS_DEPOSIT,
    REPAIR_CARD,
    INSTALLMENT_FROM_STATEMENT,
    BUSINESS_FOP,
    BUSINESS_YUO,
    KID_CARD,
    CASHBACK,
    TERMINALS,
    VYGODA_INSTALLMENT,
    BUSINESS_GOV,
    CASHBACK_UA,
    INVITE_FRIEND,
    CARDS_DESIGN,
    DIIA_CARD,
    ENERGY_ALL_NEW,
    BUSINESS_SALARY_PROJECT_NEW,
    CARDS_NEW,
    CREDITS,
    QUICK_CASH_PLUS,
    BUSINESS_ABUSINESS_NEW,
    DEPOSITS_NEW,
    HELP_DEPOSIT,
    QUICK_CASH_COMFORTABLE,
    DIIA_CARD_NEW,
    BROKERAGE_SERVICES,
    QUICK_CASH_SALARY_PLUS,
    QUICK_CASH_ZERO
} from '../Breadcrumbs/collection/breadcrumbs.config.js';

export const list = {
    menuHeaderItem: {
        cardsTitle: 'cards',
        depositTitle: 'deposits',
        creditTitle: 'credit',
        businessTitle: 'business',
        servicesTitle: 'services',
        aboutTitle: 'about',
        contacts: 'contacts'
    },

    subMenuCards: [
        {title: GREEN_CARD.title, url: GREEN_CARD.link},
        {title: YELLOW_CARD.title, url: YELLOW_CARD.link},
        {title: KID_CARD.title, url: KID_CARD.link},
        {title: PLATINUM_CARD.title, url: PLATINUM_CARD.link},
        {title: CARDS_NEW.title, url: CARDS_NEW.link}
    ],

    subMenuCards2: [
        {title: REPAIR_CARD.title, url: REPAIR_CARD.link},
        {title: PROJECT_SUPPORT.title, url: PROJECT_SUPPORT.link},
        {title: CASHBACK_UA.title, url: CASHBACK_UA.link},
        {title: DIIA_CARD_NEW.title, url: DIIA_CARD_NEW.link}
    ],

    subMenuCredit: [
        {title: PBP.title, url: PBP.link},
        {title: QUICK_CASH.title, url: QUICK_CASH.link},
        {title: DEPOSIT_CREDIT_ORDINARY.title, url: DEPOSIT_CREDIT_ORDINARY.link},
        {title: INSTALLMENT_FROM_STATEMENT.title, url: INSTALLMENT_FROM_STATEMENT.link},
        {title: VYGODA_INSTALLMENT.title, url: VYGODA_INSTALLMENT.link},
        {title: CREDITS.title, url: CREDITS.link}
    ],

    subMenuCredit2: [
        {title: QUICK_CASH_SALARY_PLUS.title, url: QUICK_CASH_SALARY_PLUS.link},
        {title: QUICK_CASH_PLUS.title, url: QUICK_CASH_PLUS.link},
        {title: QUICK_CASH_COMFORTABLE.title, url: QUICK_CASH_COMFORTABLE.link},
        {title: QUICK_CASH_ZERO.title, url: QUICK_CASH_ZERO.link}
    ],

    subMenuBusiness: [
        {title: BUSINESS_FOP.title, url: BUSINESS_FOP.link},
        {title: BUSINESS_YUO.title, url: BUSINESS_YUO.link},
        {title: BUSINESS_ACQUIRING.title, url: BUSINESS_ACQUIRING.link},
        {title: BUSINESS_SALARY_PROJECT_NEW.title, url: BUSINESS_SALARY_PROJECT_NEW.link},
        {title: ACCEPTING_PAYMENTS.title, url: ACCEPTING_PAYMENTS.link},
        {title: BUSINESS_COLLECTION.title, url: BUSINESS_COLLECTION.link}
    ],

    subMenuBusiness2: [
        {title: BUSINESS_A_EXPRESS.title, url: BUSINESS_A_EXPRESS.link},
        {title: BUSINESS_CREDIT_LINE.title, url: BUSINESS_CREDIT_LINE.link},
        {title: BUSINESS_RKO.title, url: BUSINESS_RKO.link},
        {title: DEPOSIT_CREDIT.title, url: DEPOSIT_CREDIT.link},
        {title: ENERGY_ALL_NEW.title, url: ENERGY_ALL_NEW.link},
        {title: BUSINESS_GOV.title, url: BUSINESS_GOV.link}
    ],

    subMenuBusiness3: [
        {title: BUSINESS_ABUSINESS_NEW.title, url: BUSINESS_ABUSINESS_NEW.link},
        {title: BUSINESS_DEPOSITS.title, url: BUSINESS_DEPOSITS.link},
        {title: BUSINESS_VED_CONTRACT.title, url: BUSINESS_VED_CONTRACT.link},
        {title: BUSINESS_GUARANTEES.title, url: BUSINESS_GUARANTEES.link},
        {title: PBP_ENTITY.title, url: PBP_ENTITY.link}
    ],

    subMenuServices: [
        {title: ABANK24.title, url: ABANK24.link},
        {title: PAYMENTS.title, url: PAYMENTS.link},
        {title: SERVICES_TRANSFERS.title, url: SERVICES_TRANSFERS.link},
        {title: PENSION.title, url: PENSION.link},
        {title: INSURANCE.title, url: INSURANCE.link},
        {title: SAFE_BOXES.title, url: SAFE_BOXES.link},
        {title: INVITE_FRIEND.title, url: INVITE_FRIEND.link},
        {title: CARDS_DESIGN.title, url: CARDS_DESIGN.link},
        {title: PAYMENT_BY_PHONE.title, url: PAYMENT_BY_PHONE.link}
    ],

    subMenuServices2: [
        {title: DOCUMENTS.title, url: DOCUMENTS.link},
        {title: PESSONAL_DATA.title, url: PESSONAL_DATA.link}
    ],

    subMenuServices3: [
        {title: SERVICE_LEASING.title, url: SERVICE_LEASING.link},
        {title: TERMINALS.title, url: TERMINALS.link},
        {title: ABROAD.title, url: ABROAD.link},
        {title: WAR_TIME.title, url: WAR_TIME.link},
        {title: CASHBACK.title, url: CASHBACK.link},
        {title: BROKERAGE_SERVICES.title, url: BROKERAGE_SERVICES.link}
    ],

    subMenuAbout: [
        {title: ABOUT_BANK_GENERAL.title, url: ABOUT_BANK_GENERAL.link},
        {title: ABOUT_BANK_OWNERS.title, url: ABOUT_BANK_OWNERS.link},
        {title: ABOUT_BANK_REPORTS.title, url: ABOUT_BANK_REPORTS.link},
        {title: ABOUT_BANK_TOP.title, url: ABOUT_BANK_TOP.link},
        {title: ABOUT_BANK_STRATEGY.title, url: ABOUT_BANK_STRATEGY.link}
    ],

    subMenuDeposits: [
        {title: TRANSFER_BONUS.title, url: TRANSFER_BONUS.link},
        {title: ONLINE_DEPOSIT.title, url: ONLINE_DEPOSIT.link},
        {title: HELP_DEPOSIT.title, url: HELP_DEPOSIT.link},
        {title: DEPOSITS_NEW.title, url: DEPOSITS_NEW.link}
    ],

    subMenuDeposits2: [
        {title: CALCULATOR_DEPOSIT.title, url: CALCULATOR_DEPOSIT.link},
        {title: TARIFFS_DEPOSIT.title, url: TARIFFS_DEPOSIT.link},
        {title: FGVO.title, url: FGVO.link}
    ]
};
